import React from "react";
import { Blocks } from "@/types/cms";
import { renderRichTextWithMutedStrikethrough } from "@/lib/richText";
import { resolveLucideIcon } from "@/lib/lucideIcon";
import styles from "./SectionHeader.module.css";

interface SectionHeaderProps {
  content?: Blocks;
  align?: 'left' | 'center' | 'right';
  textAlign?: 'left' | 'center' | 'right';
  headerWidth?: 'sm' | 'md' | 'lg';
  eyebrow?: string;
  icon?: string;
}

const SectionHeader = ({ content, align = 'center', textAlign, headerWidth, eyebrow, icon }: SectionHeaderProps) => {
  if (!content && !eyebrow) return null;

  const eyebrowIcon = resolveLucideIcon(icon);

  // For center alignment, keep text left but center the wrapper unless textAlign overrides
  const containerAlign = textAlign
    ? (textAlign === 'left' ? styles.alignLeft : textAlign === 'right' ? styles.alignRight : styles.alignCenter)
    : (align === 'right' ? styles.alignRight : styles.alignLeft);
  const wrapperJustify = align === 'left' ? styles.justifyStart : align === 'right' ? styles.justifyEnd : styles.justifyCenter;

  const widthClass = headerWidth === 'sm' ? styles.wSm : headerWidth === 'lg' ? styles.wLg : headerWidth === 'md' ? styles.wMd : '';

  return (
    <div className={`${styles.container} ${containerAlign} ${widthClass}`}>
      <div className={`${styles.row} ${wrapperJustify}`}>
        <div className={styles.textWrap}>
          {eyebrow && (
            <div className={styles.eyebrowRow}>
              {eyebrowIcon &&
                React.createElement(eyebrowIcon, {
                  className: styles.eyebrowIcon,
                  strokeWidth: 1.5,
                })}
              <span className={`eyebrow ${styles.eyebrow}`}>{eyebrow}</span>
            </div>
          )}
          {content && (
            <div className={`${styles.full} ${styles.content}`}>
              {renderRichTextWithMutedStrikethrough(content, {
                defaultAlign: textAlign,
                headingVariant: "accent",
                // Shared running-copy treatment (18px desktop / 16px mobile),
                // same as card bodies and the hero subtitle. Was `body-lg`
                // (20px, no mobile step), which left the intro towering over
                // the cards below it on a phone.
                paragraphClass: "body-copy",
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;


